import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getTagListInit.query';

export const getContractTagsInit = ({ projectId }: QueryParams) => {
    const querystring = qs.stringify({ projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/management/getContractTagsInit${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
